import React, { useEffect, useState } from "react";
import axios from "axios";

import { Link } from "react-router-dom";
import Modal from 'react-modal';

import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faCrown, faFaceAngry, faGamepad, faList, faLock, faPlus, faUser } from "@fortawesome/free-solid-svg-icons";

import Navbar from '../../Components/Navbar';


const ProfilPage = (props) => {
    const token = localStorage.getItem("JWT");

    const [modalIsOpen, setIsOpen] = useState(false);         //gestion de la modal

    const [UEC, setUEC] = useState("");
    const [PP, setPP] = useState("");
    const [warbond, setWarbond] = useState("");
    const [pseudo, setPseudo] = useState("");
    const [rang, setRang] = useState("");
    const [rangPriorite, setRangPriorite] = useState(1);
    const [allEncadrements, setAllEncadrements] = useState([]);
    const [avatarUrl, setAvatarUrl] = useState('');

    const [carteCount, setCarteCount] = useState("");
    const [cadreCount, setCadreCount] = useState("");
    const [avatarCount, setAvatarCount] = useState("");
    const [cartePercent, setCartePercent] = useState("");
    const [cadrePercent, setCadrePercent] = useState("");
    const [avatarPercent, setAvatarPercent] = useState("");

    const [chefDeGroupePlus, setChefDeGroupePlus] = useState(false);
    const [dev, setDev] = useState(false);
    const [officier, setOfficier] = useState(false);
    const [designer, setDesigner] = useState(false);

    //-----------------------------------------------------Gestion de la modal---------------------------------------------------------//
    Modal.setAppElement('#root'); // Assurez-vous de définir l'élément racine pour des raisons d'accessibilité

    const customStyles = {      // gestion du style de la modal
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: "70%",
            backgroundColor: "rgba(18, 18, 18, 0.35)",
            padding: "15px",
            border: "none",
            zIndex: "99",
        },
    };

    const mediaQueryStyles = {
        '@media (min-width: 1025px) and (max-width: 1440px)': {
            content: {
                width: "70%",
                height: "70%",
            },
        },
        '@media (min-width: 1921px) and (max-width: 2560px)': {
            content: {
                width: "75%",
                height: "90%",
            },
        },
        '@media (min-width: 2561px) and (max-width: 3440px)': {
            content: {
                width: "50%",
                height: "90%",
            },
        },
    };

    function openModal(e) {         // ouverture de la modale 
        const updatedStyles = { ...customStyles };

        if (window.matchMedia('(min-width: 1025px) and (max-width: 1440px)').matches) {
            updatedStyles.content = {
                ...customStyles.content,
                ...mediaQueryStyles['@media (min-width: 1025px) and (max-width: 1440px)'].content,
            };
        }
        if (window.matchMedia('(min-width: 1921px) and (max-width: 2560px)').matches) {
            updatedStyles.content = {
                ...customStyles.content,
                ...mediaQueryStyles['@media (min-width: 1921px) and (max-width: 2560px)'].content,
            };
        }
        if (window.matchMedia('(min-width: 2561px) and (max-width: 3440px)').matches) {
            updatedStyles.content = {
                ...customStyles.content,
                ...mediaQueryStyles['@media (min-width: 2561px) and (max-width: 3440px)'].content,
            };
        }
        setModalStyles(updatedStyles);
        setIsOpen(true);
    }

    function closeModal() {         // fermeture de la modal
        setIsOpen(false);
    }

    const [modalStyles, setModalStyles] = React.useState(customStyles);

    //-----------------------------------------------------Get One user pour affichage des datas---------------------------------------------------------//

    function getOneUser() {
        const userId = localStorage.getItem("userId");

        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}api/auth/user/${userId}`,
            headers: {
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            }
        })
            .then((res) => {
                setRangPriorite(res.data.rang.priorite);
                setUEC(res.data.UEC);
                setWarbond(res.data.warbonds);
                setPP(res.data.PP);
                setPseudo(res.data.pseudoFCU);
                setRang(res.data.rang.nom);
                setAllEncadrements(res.data.encadrements)
                setAvatarUrl(res.data.selectAvatar);

                // gestion de l'affichage des assets
                let focusCarteCont = document.querySelector(".infoTop");
                focusCarteCont.style.backgroundImage = `url(${res.data.selectCarte})`;

                // Vérifiez si l'utilisateur a un encadrement nommé "Officier"
                if (res.data.encadrements.some(encadrement => encadrement.nom === "Officier")) {
                    setOfficier(true)
                }

                // Vérifiez si l'utilisateur a un encadrement au dessus de "Chef de groupe"
                if (res.data.encadrements.some(encadrement => encadrement.priorite >= 2)) {
                    setChefDeGroupePlus(true);
                }

                // Vérifiez si l'utilisateur a une division nommé "Dev"
                if (res.data.divisions.some(division => division.nom === "Dev")) {
                    setDev(true);
                }
                if (res.data.divisions.some(division => division.nom === "RH")) {
                    setChefDeGroupePlus(true);
                }
                if (res.data.divisions.some(division => division.nom === "Designer")) {
                    setDesigner(true);
                }

            })
            .catch((err) => {
                console.log(err);
            });
    }

    function getOneUserStat() {
        const userId = localStorage.getItem("userId");

        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}api/auth/userStat/${userId}`,
            headers: {
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            }
        })
            .then((res) => {
                setAvatarCount(res.data.userAvatarStat)
                setCarteCount(res.data.userCarteStat)
                setCadreCount(res.data.userCadresStat)
                setAvatarPercent(res.data.userAvatarPercentage)
                setCartePercent(res.data.userCartePercentage)
                setCadrePercent(res.data.userCadrePercentage)
            })
            .catch((err) => {
                console.log(err);
            });
    }



    useEffect(() => {
        getOneUser()
        getOneUserStat()
    }, []);

    return (
        <div id='profilPage' className='profilPage'>

            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={modalStyles}
                contentLabel="modal profil"
                ariaHideApp={false}
            >
                <div className='modalProfil'>
                    <img src="images/profil/equipement.jpg" alt="logo rang FCU" />
                </div>
            </Modal>

            <div className="avatarCont">
                <img src={avatarUrl} alt="avatar FCU" />

                <svg onClick={openModal} expanded="true" height="100px" width="100px">
                    <circle class="innerCircle" cx="50%" cy="50%" r="25%" fill="none" stroke="#ffd204" stroke-width="5%">
                        <animate attributeType="SVG" attributeName="r" begin="0s" dur="1.5s" repeatCount="indefinite" from="5%" to="25%" />
                        <animate attributeType="CSS" attributeName="stroke-width" begin="0s" dur="1.5s" repeatCount="indefinite" from="3%" to="0%" />
                        <animate attributeType="CSS" attributeName="opacity" begin="0s" dur="1.5s" repeatCount="indefinite" from="1" to="0" />
                    </circle>
                </svg>
            </div>

            <Navbar />
            <div className='profilPage__profilContainer'>


                <div className="adminButton">

                    {(chefDeGroupePlus || dev) &&
                        <Link className="adminLink" to="/membres">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="128"
                                height="128"
                                viewBox="0 0 24 24"
                            >
                                <circle cx="4" cy="10" r="2" />
                                <path d="M6.67 13.4A4.19 4.19 0 0 0 5 16.75V17H.75c-.41 0-.75-.34-.75-.75v-.5C0 14.23 1.23 13 2.75 13h2.5c.52 0 1.01.15 1.42.4z" />
                                <circle cx="20" cy="10" r="2" />
                                <path d="M24 15.75v.5c0 .41-.34.75-.75.75H19v-.25c0-1.37-.66-2.59-1.67-3.35.41-.25.9-.4 1.42-.4h2.5c1.52 0 2.75 1.23 2.75 2.75z" />
                                <circle cx="12" cy="9.5" r="3" />
                                <path d="M14.75 14h-5.5a2.752 2.752 0 0 0-2.75 2.75v1.5c0 .414.336.75.75.75h9.5a.75.75 0 0 0 .75-.75v-1.5A2.752 2.752 0 0 0 14.75 14z" />
                            </svg>
                        </Link>
                    }

                    {/* {dev &&
                        <Link className="adminLink" to="/creationEvent">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="128"
                                height="128"
                                viewBox="0 0 24 24"
                            >
                                <path d="M3.75 15h2.5a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0-.75.75v2.5c0 .414.336.75.75.75zM3.75 21h2.5a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0-.75.75v2.5c0 .414.336.75.75.75zM10.75 15h2.5a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0-.75.75v2.5c0 .414.336.75.75.75zM10.75 21h2.5a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0-.75.75v2.5c0 .414.336.75.75.75zM17.75 15h2.5a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0-.75.75v2.5c0 .414.336.75.75.75z" />
                                <path d="M21 3h-1V1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v2H7V1a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2H3C1.346 3 0 4.346 0 6v15c0 1.654 1.346 3 3 3h18c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3zm1 18c0 .551-.449 1-1 1H3c-.551 0-1-.449-1-1V10.04h20V21z" />
                            </svg>
                        </Link>
                    } */}

                    {/* {dev &&
                        <Link className="adminLink" to="/adminEvent">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="128"
                                height="128"
                                viewBox="0 0 24 24"
                            >
                                <path d="M9.25 20h-4.5C3.785 20 3 19.215 3 18.25v-4.5c0-.965.785-1.75 1.75-1.75h4.5c.965 0 1.75.785 1.75 1.75v4.5c0 .965-.785 1.75-1.75 1.75zM16.75 19.25a1 1 0 0 1-.747-.335l-2-2.25a1 1 0 0 1 1.494-1.329l1.201 1.352 2.763-3.551a.999.999 0 1 1 1.578 1.227l-3.5 4.5a.998.998 0 0 1-.756.386h-.033z" />
                                <path d="M21 3h-1V1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v2H7V1a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2H3C1.346 3 0 4.346 0 6v15c0 1.654 1.346 3 3 3h18c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3zm0 19H3a1 1 0 0 1-1-1V9.04h20V21a1 1 0 0 1-1 1z" />
                            </svg>
                        </Link>
                    } */}

                    {(designer || dev) &&
                        <Link className="adminLink" to="/AdminGalerie">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="128" height="128" viewBox="0 0 24 24">
                                <circle cx="4.5" cy="6.5" r="1.5" />
                                <path d="M21.5 8.5v6.053a3.951 3.951 0 0 1-3.947 3.947H7.5v1c0 1.378 1.122 2.5 2.5 2.5h11.5c1.378 0 2.5-1.122 2.5-2.5V11c0-1.378-1.122-2.5-2.5-2.5z" />
                                <path d="M17.553 2H2.447A2.45 2.45 0 0 0 0 4.447v10.105c0 .173.019.342.054.505a.74.74 0 0 0 .186.703c.042.042.095.065.144.095A2.44 2.44 0 0 0 2.447 17h15.105A2.45 2.45 0 0 0 20 14.553V4.447A2.45 2.45 0 0 0 17.553 2zM2.447 4h15.105c.247 0 .448.201.448.447v6.152l-3.159-3.685c-.335-.394-.798-.585-1.341-.615a1.749 1.749 0 0 0-1.336.631L8.45 11.389 7.24 10.18a1.755 1.755 0 0 0-2.48 0L2 12.939V4.447C2 4.201 2.201 4 2.447 4z" />
                            </svg>
                        </Link>
                    }

                    {(dev || officier) &&
                        <Link className="adminLink" to="/logs">
                            <svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 24 24"><path d="M3.5 2h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zM3.5 10h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zM3.5 18h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zM8 5h15a1 1 0 1 0 0-2H8a1 1 0 1 0 0 2zM23 11H8a1 1 0 1 0 0 2h15a1 1 0 1 0 0-2zM23 19H8a1 1 0 1 0 0 2h15a1 1 0 1 0 0-2z" /></svg>
                        </Link>
                    }

                    {dev &&
                        <Link className="adminLink" to="/ajouter">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="128" height="128" viewBox="0 0 24 24">
                                <path d="M18.75 9H18V6c0-3.309-2.691-6-6-6S6 2.691 6 6v3h-.75A2.253 2.253 0 0 0 3 11.25v10.5C3 22.991 4.01 24 5.25 24h13.5c1.24 0 2.25-1.009 2.25-2.25v-10.5C21 10.009 19.99 9 18.75 9zM8 6c0-2.206 1.794-4 4-4s4 1.794 4 4v3H8V6zm5 10.722V19a1 1 0 1 1-2 0v-2.278c-.595-.347-1-.985-1-1.722 0-1.103.897-2 2-2s2 .897 2 2c0 .737-.405 1.375-1 1.722z" />
                            </svg>
                        </Link>
                    }
                 
                </div>

                <div className="profilPage__profilContainer__info1">
                    <div className="infoTop">

                        <div className="infoTop__infoTopCont">

                            <div className="infoTop__infoTopCont__top">
                                {/* <span>
                                    <img src="images/logoFCUBlanc.png" alt="logo rang FCU" />
                                    <h2>{rang}</h2>
                                </span> */}

                            </div>

                            <div className="infoTop__infoTopCont__bot">
                                <div className="infoTop__infoTopCont__bot__rank">

                                    <div className="memberPseudo">
                                        <h2>{pseudo}</h2>

                                        <div className="encadrement">
                                            {allEncadrements.map((encadrement, index) => (
                                                <p key={encadrement.id} >{encadrement.nom}{index < allEncadrements.length - 1 ? '/' : ''}</p>
                                            ))}
                                        </div>
                                    </div>


                                    <div className="porteMonnaies">
                                        {/* <div >
                                            {UEC !== undefined && <p>{UEC.toLocaleString("fr-FR")}</p>}
                                            <img src="images/uec.png" alt="logo uec" />
                                        </div> */}
                                        <div >
                                            <p >{PP}</p>
                                            <img src="images/PP.png" alt="logo Warbond" />
                                        </div>
                                        <div >
                                            {warbond !== undefined && <p>{warbond.toLocaleString("fr-FR")}</p>}
                                            <img src="images/warbond.png" alt="logo Warbond" />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="infoBot">
                        <img src="../../../images/vitrine/slide4/topBackground.png" />


                        <p className="rankProgressTitle">Suivez votre progression au sein de la FCU</p>
                        <div className="infoBot__section1">
                            {/* <div className="infoBot__section1__rankProgress">
                                <CircularProgressbar value={percentageRank} text={`${percentageRank}%`} />
                                <p>Rangs débloqués</p>
                            </div> */}
                            <div className="infoBot__section1__rankProgress">
                                <CircularProgressbar value={cartePercent} text={`${carteCount}`} />
                                <p>Cartes</p>
                            </div>
                            <div className="infoBot__section1__rankProgress">
                                <CircularProgressbar value={avatarPercent} text={`${avatarCount}`} />
                                <p>Avatars</p>
                            </div>
                            <div className="infoBot__section1__rankProgress">
                                <CircularProgressbar value={cadrePercent} text={`${cadreCount}`} />
                                <p>Cadres</p>
                            </div>
                        </div>

                        <div className="infoBot__section2">

                            <span>
                                <p>Profitez des ressources proposées par la FCU pour monter en compétences. </p>
                                <Link id="biblioButton" className={`DashboardLinks__container__content__button ${rangPriorite < 1 ? " forbidenButton" : ""}`} to="/bibliotheque">Bibliothèque</Link>

                                {rangPriorite < 1 &&
                                    <p className="forbidenTextForBiblio">Accessible a partir du rang recrue</p>
                                }
                            </span>
                            <span>
                                <p>Personnalisez votre carte membre depuis votre inventaire. </p>
                                <Link className="DashboardLinks__container__content__button" to="/inventaire">Inventaire</Link>
                            </span>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfilPage;